import { defineMessages } from 'react-intl-next';

export default defineMessages({
	refineButton: {
		id: 'fabric.editor.ai.screens.preview.refineDropdown.refineButton',
		defaultMessage: 'Refine',
		description: 'The action text for the refine button to edit the previewed generated content',
	},
});
